/*
  Action Types
 */

export const GET_TRADING_HOURS = 'GET_TRADING_HOURS';
export const GET_MERCHANTS = 'GET_MERCHANTS';
export const GET_MERCHANTS_SUCCESS = 'GET_MERCHANTS_SUCCESS';
export const UPDATE_TRADING_HOURS = 'UPDATE_TRADING_HOURS';
export const POST_TRADING_HOURS = 'POST_TRADING_HOURS';
export const POST_TRADING_HOURS_SUCCESS = 'POST_TRADING_HOURS_SUCCESS';


// WEBPACK FOOTER //
// ./app/profile/constants/profileConstants.js